import { getPlayHeadWrapperPadding } from 'utils'

export const updateMagnetizingLineStyles = (
  element: HTMLDivElement,
  display: string,
  newPosition: number
) => {
  element.style.display = display
  element.style.left = `${newPosition + getPlayHeadWrapperPadding()}px`
}
